import Navigation from "@/components/Navigation";
import { Card, CardContent } from "@/components/ui/card";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { Helmet } from "react-helmet";
import ChineseZodiacIcon from "@/components/ChineseZodiacIcon";

const HoroscopoMono = () => {
  return (
    <div className="min-h-screen bg-background">
      <Helmet>
        <title>Horóscopo Chino Mono - Predicciones Diarias | Midstino</title>
        <meta name="description" content="Horóscopo chino del signo Mono. Predicciones diarias de amor, trabajo y salud para los nacidos en los años del Mono." />
      </Helmet>
      
      <Navigation />
      
      <main className="container mx-auto px-4 pt-24 pb-12">
        <Card className="max-w-4xl mx-auto">
          <CardContent className="p-8">
            <div className="text-center mb-6">
              <div className="flex justify-center mb-4">
                <ChineseZodiacIcon animal="mono" size={96} />
              </div>
              <h1 className="text-3xl font-bold mb-2">Mono</h1>
              <p className="text-muted-foreground">Años: 1932, 1944, 1956, 1968, 1980, 1992, 2004, 2016, 2028</p>
            </div>

            <Tabs defaultValue="hoy" className="w-full">
              <TabsList className="grid w-full grid-cols-3">
                <TabsTrigger value="hoy">Hoy</TabsTrigger>
                <TabsTrigger value="manana">Mañana</TabsTrigger>
                <TabsTrigger value="semana">Esta Semana</TabsTrigger>
              </TabsList>

              <TabsContent value="hoy" className="space-y-6">
                <div>
                  <h2 className="text-xl font-semibold mb-3 text-primary">💝 Amor</h2>
                  <p className="text-muted-foreground leading-relaxed">
                    Tu encanto juguetón y sentido del humor están irresistibles hoy, Mono. Tu energía contagiosa atraerá admiradores. Las parejas disfrutarán de momentos divertidos y llenos de risa compartida.
                  </p>
                </div>
                <div>
                  <h2 className="text-xl font-semibold mb-3 text-primary">💼 Trabajo</h2>
                  <p className="text-muted-foreground leading-relaxed">
                    Tu inteligencia ágil y capacidad de resolver problemas brillarán hoy. Es momento perfecto para presentar ideas innovadoras. Tu versatilidad te permite adaptarte a cualquier situación.
                  </p>
                </div>
                <div>
                  <h2 className="text-xl font-semibold mb-3 text-primary">🏥 Salud</h2>
                  <p className="text-muted-foreground leading-relaxed">
                    Tu energía mental está en su pico. Mantén tu mente activa con actividades estimulantes, pero no descuides el ejercicio físico. Tu bienestar requiere equilibrio entre mente y cuerpo.
                  </p>
                </div>
              </TabsContent>

              <TabsContent value="manana" className="space-y-6">
                <div>
                  <h2 className="text-xl font-semibold mb-3 text-primary">💝 Amor</h2>
                  <p className="text-muted-foreground leading-relaxed">
                    Mañana será perfecto para sorpresas divertidas y espontáneas. Tu creatividad en el romance mantendrá la chispa viva. Los solteros podrían conocer a alguien en situaciones sociales animadas.
                  </p>
                </div>
                <div>
                  <h2 className="text-xl font-semibold mb-3 text-primary">💼 Trabajo</h2>
                  <p className="text-muted-foreground leading-relaxed">
                    Tu ingenio encontrará soluciones donde otros ven obstáculos. Oportunidades que requieren pensamiento rápido y adaptabilidad estarán a tu favor. Confía en tu creatividad natural.
                  </p>
                </div>
                <div>
                  <h2 className="text-xl font-semibold mb-3 text-primary">🏥 Salud</h2>
                  <p className="text-muted-foreground leading-relaxed">
                    Tu vitalidad estará excelente. Actividades que combinen diversión y ejercicio serán ideales. Deportes de equipo o clases grupales satisfarán tu necesidad de socialización y movimiento.
                  </p>
                </div>
              </TabsContent>

              <TabsContent value="semana" className="space-y-6">
                <div>
                  <h2 className="text-xl font-semibold mb-3 text-primary">💝 Amor</h2>
                  <p className="text-muted-foreground leading-relaxed">
                    Una semana emocionante y llena de sorpresas en el amor. Tu carisma natural atraerá situaciones románticas interesantes. Las parejas explorarán nuevas formas de mantener la relación fresca.
                  </p>
                </div>
                <div>
                  <h2 className="text-xl font-semibold mb-3 text-primary">💼 Trabajo</h2>
                  <p className="text-muted-foreground leading-relaxed">
                    Esta semana tu versatilidad será tu mayor fortaleza. Múltiples proyectos se beneficiarán de tu capacidad de multitarea. Tu ingenio abrirá puertas a oportunidades inesperadas.
                  </p>
                </div>
                <div>
                  <h2 className="text-xl font-semibold mb-3 text-primary">🏥 Salud</h2>
                  <p className="text-muted-foreground leading-relaxed">
                    Mantén tu energía diversificada con variedad de actividades. Tu naturaleza curiosa necesita estimulación constante. Equilibra actividades mentales y físicas para óptimo bienestar.
                  </p>
                </div>
              </TabsContent>
            </Tabs>
          </CardContent>
        </Card>
      </main>
    </div>
  );
};

export default HoroscopoMono;
